module.exports = __webpack_public_path__ + "static/media/group.769f5d0f.svg";